import classNames from 'classnames/bind';
import styles from './ActivityCard.module.css';
import { ActivityCardProps, CardSize } from '../../../types/dashboard';
import DashIcon from '../Icon';
import ConditionalWrapper from '../../ConditionalWrapper';

const getCardSettings = (cardId: string) => {
  const id = cardId.toLowerCase();
  const isLastLearning = id.includes('last-learning');
  const isWide = isLastLearning;
  const isBeta = isLastLearning || id.includes('keyword');

  return {
    size: isWide ? CardSize.WIDE : CardSize.DEFAULT,
    isBeta,
    isLastLearning,
  };
};

export default function ActivityCard({
  id,
  title,
  value,
  coverImage,
  onClick,
}: ActivityCardProps) {
  const cx = classNames.bind(styles);

  const { size, isBeta, isLastLearning } = getCardSettings(id);

  return (
    <li
      className={cx(
        'learning-activity_item',
        { wide: size === CardSize.WIDE },
        { beta: isBeta }
      )}
      onClick={() => onClick?.(id)}
    >
      <ConditionalWrapper
        condition={isLastLearning}
        wrapper={(children) => (
          <div>
            {children}
            {coverImage && (
              <div className={cx('learning-activity_item_img')}>
                <img src={coverImage} alt={value} />
              </div>
            )}
          </div>
        )}
      >
        <div>
          <div className={cx('learning-activity_item_title')}>
            <DashIcon cardId={id} />
            <span className={cx('title')}>{title}</span>
          </div>
          <div className={cx('learning-activity_item_content')}>
            <p>{value}</p>
          </div>
        </div>
      </ConditionalWrapper>
    </li>
  );
}
